module.exports = __webpack_public_path__ + "img/book_img.60410eb6.svg";